const CATEGORY_RULES = [
  { category: 'Urology', match: [/urolog/i] },
  { category: 'General Surgery', match: [/general/i, /surgeon/i] },
  { category: 'Orthopedics', match: [/ortho/i] },
  { category: 'Cardiology', match: [/cardio/i] },
  { category: 'Neurology / Neurosurgery', match: [/neuro/i] },
  { category: 'Gastroenterology', match: [/gastro/i] },
  { category: 'Pulmonology', match: [/pulmono/i, /chest/i] },
  { category: 'Dermatology', match: [/derma/i, /skin/i] },
  { category: 'ENT', match: [/\bent\b/i, /otolar/i] },
  { category: 'Gynecology', match: [/gyn/i, /obstet/i] },
  { category: 'Pediatrics', match: [/pediatric/i, /\bpeads?\b/i, /child/i] },
  { category: 'Psychiatry', match: [/psychi/i] },
  { category: 'Psychology / Speech', match: [/psycholog/i, /speech/i, /therap/i] },
  { category: 'Radiology', match: [/radiolog/i] },
  { category: 'Physiotherapy', match: [/physio/i, /therapy/i] },
  { category: 'Diet & Nutrition', match: [/diet/i, /nutrition/i] },
  { category: 'Internal Medicine', match: [/medical specialist/i, /internal/i, /physician/i] },
  { category: 'Oncology', match: [/onco/i, /cancer/i] },
  { category: 'Dentistry', match: [/dent/i] },
  { category: 'Ophthalmology', match: [/ophthal/i, /eye/i] },
  { category: 'Plastic Surgery', match: [/plastic/i] },
];

export function toSpecialtyCategory(rawSpecialty) {
  const raw = String(rawSpecialty || '').replace(/\s+/g, ' ').trim();
  if (!raw) return 'Other';

  for (const rule of CATEGORY_RULES) {
    const ok = rule.match.every((re) => re.test(raw));
    if (ok) return rule.category;
  }

  // Single-regex rules (fallback)
  for (const rule of CATEGORY_RULES) {
    const okAny = rule.match.some((re) => re.test(raw));
    if (okAny) return rule.category;
  }

  return raw;
}

